import React, {useState, useEffect} from 'react';
import ActionFormLayout from '../../../../../../components/layouts/actions/ActionFormLayouts';
import TeamChoice from '../../../../../../components/customForm/teamchoice/TeamChoice';
import Title from '../../../../../../components/Title';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchLive, addActionLive, editActionLive } from '../../../../../../actions/liveDataActions';
import queryString from 'query-string';
import { getChronoFromLiveDebut } from '../../../../../../helpers';
import { List } from 'antd-mobile';
import NumberInput from '../../../../../../components/customForm/number/NumberInput';
import PickerInput from '../../../../../../components/customForm/picker/PickerInput';
import './PenaltyDeclarationPage.css';
import { addAction } from '../../../../../../services/live';
import { editAction } from '../../../../../../services/action';
import _ from 'lodash';
import { LOGO_TEAM_URL } from '../../../../../../config.env';

const PenaltyDeclarationPage = props => {
    const history = useHistory();
    const access = props.connexionReducer;
    const [formValid, setFormValid] = useState(false);
    const {id} = useParams();
    const match = props.liveDataReducer[`/api/lives/${id}`] ? props.liveDataReducer[`/api/lives/${id}`].match : {};
    const qs = queryString.parse(props.history.location.search);
    const dataEdited = qs.action_edit ? JSON.parse(qs.action_edit) : null;
    const [team, setTeam] = useState(dataEdited ? dataEdited.teamId : '');
    const [teamName, setTeamName] = useState(dataEdited ? dataEdited.teamName : '');
    const min = qs.actions ? parseInt(getChronoFromLiveDebut(JSON.parse(qs.actions))) : 0;
    const [minute, setMinute] = useState(dataEdited ? dataEdited.minute || 0 : min);
    const [teamSanctioned, setTeamSanctioned] = useState(dataEdited ? dataEdited.data.teamSanctioned : '');
    const [category, setCategory] = useState(dataEdited ? dataEdited.data.category : '');
    const [sanction, setSanction] = useState(dataEdited ? dataEdited.data.sanction : '');
    const dataSanctions = [
        {label: 'à renseigner', value: ''},
        {label: 'Carton jaune', value: 'carton jaune'},
        {label: 'Carton rouge', value: 'carton rouge'},
        {label: 'Carton blanc', value: 'carton blanc'}
    ];
    const actionId = qs.action_type ? JSON.parse(qs.action_type)['@id'] : (dataEdited && dataEdited.type ? dataEdited.type['@id'] : '');
    const score = qs.score ? JSON.parse(qs.score) : {home: null, away: null};
    const slug = qs.action_type ? JSON.parse(qs.action_type)['slug'] : (dataEdited && dataEdited.type ? dataEdited.type.slug : '');
    const editId = dataEdited ? dataEdited['@id'] : '';
    const nextStepSettings = qs.settings ? JSON.parse(qs.settings) : {};
    const relatedAction = dataEdited ? dataEdited.data.relatedAction : {};
    const [showBtnSubmit, setShowBtnSubmit] = useState(true);
    const [isOnSubmit, setIsOnSubmit] = useState(false);

    useEffect(() => {
        if(access) {
            props.fetchLive(id, access);
        }
        setFormValid(team !== '' && minute !== '' && minute !== null)
    }, [access, team, minute]);

    return(
        <ActionFormLayout 
            title='Penalty'
            submit={() => next(id, actionId, {
                team, 
                teamName, 
                minute, 
                teamSanctioned, 
                sanction, 
                slug, 
                score, 
                nextStepSettings, 
                category}, access, editId, props.addActionLive, history,props.editActionLive, relatedAction, setFormValid, setIsOnSubmit)}
            enabled={formValid}
            okBtn={editId ? 'valider' : 'étape suivante'}
            id='declare_penalty'
            style={{margin: '0 0 0 -100%', width: '100%', height: '100%'}}
            onShow={() => {
                const element = document.getElementById('declare_penalty')
                element.classList.add('animated-declare_penalty')
            }}
            previousStep={() => history.push(`/live/${id}`)}
            showBtn={showBtnSubmit}
            isOnSubmit={isOnSubmit}
        >
            <div className='ls_debut_form'>
                <TeamChoice 
                    header={() => <Title text='équipe qui a reçu le penalty' />}
                    teams={[
                        {icon: `${LOGO_TEAM_URL}/${match.homeTeamClCod}.jpg`, text: match.homeTeam, teamId: match.homeTeamClCod, category: 'home', name: match.homeTeamEqName},
                        {icon: `${LOGO_TEAM_URL}/${match.awayTeamClCod}.jpg`, text: match.awayTeam, teamId: match.awayTeamClCod, category: 'away', name: match.awayTeamEqName}
                    ]}
                    teamName={team}
                    onChange={(id, name, category) => {
                        setTeam(id);
                        setTeamName(name);
                        setTeamSanctioned(category === 'home' ? match.awayTeam : match.homeTeam);
                        setCategory(category);
                    }}
                />
            </div>
            <List renderHeader={() => <Title text='détails du penalty' />}>
                <NumberInput 
                    label='Minute' 
                    min={0}
                    value={minute}
                    defaultValue={minute} 
                    onChange={setMinute} 
                    id='ls_minute_declaration_penalty'
                    onFocus={() => setShowBtnSubmit(false)} 
                    onBlur={() => setShowBtnSubmit(true)}
                />
                <PickerInput data={dataSanctions} label={'Sanction pour l\'équipe adverse'} extra='à renseigner' value={sanction} onOk={setSanction} />
            </List>
        </ActionFormLayout>
    )
}

const next = (id, actionId, data, access, editId, addActionLive, history, editActionLive, relatedAction, setFormValid, setIsOnSubmit) => {
    setFormValid(false);
    setIsOnSubmit(true);
    const dataDeclarePenalty = {
        label: 'penalty_declaration',
        actionName: `Penalty pour ${data.teamName}`,
        description: `${data.sanction !== '' ? `${data.sanction} pour ${data.teamSanctioned}` : ''}`,
        sanction: data.sanction,
        teamSanctioned: data.teamSanctioned,
        category: data.category,
        score: data.score
    }
    if(editId) {
        editAction(editId, {
            teamId: parseInt(data.team),
            teamName: data.teamName,
            minute: parseInt(data.minute),
            data: dataDeclarePenalty
        }, access, id, actionId).then(response => {
            setIsOnSubmit(false);
            editActionLive(id, response.data);
            history.push(`/live/${id}`)
        });
    }
    else {
        addAction(id, {
            type: actionId,
            teamId: parseInt(data.team),
            teamName: data.teamName,
            minute: parseInt(data.minute),
            data: dataDeclarePenalty
        }, access).then(response => {
            window.postMessage(JSON.stringify({
                action: 'trackEvent',
                parameters: {
                    label: 'added_live_score',
                    value: 'déclarer un penalty'
                }
            }), '*');
            setIsOnSubmit(false);
            addActionLive(id, response.data);
            const settings = _.assignIn(data.nextStepSettings, {
                teamId: data.team,
                teamName: data.teamName,
                minute: data.minute,
                category: data.category,
                score: data.score,
                prevAction: _.findLast(response.data.actions, a => a.type['@id'] === actionId || a.type === actionId)

            });
            history.push(`/live/${id}/penalty_resultat?settings=${JSON.stringify(settings)}`);
        })
    }
}

const mapStateToProps = ({liveDataReducer, connexionReducer}) => ({liveDataReducer, connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({fetchLive, addActionLive, editActionLive}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PenaltyDeclarationPage);